import { Image, Text, View } from "@react-pdf/renderer";
import styles from "./styles";
import { MatchQuestionType } from "../types";
import { t } from "i18next";

function shuffleArray<T>(array: T[]): T[] {
  const newArray = [...array];
  for (let i = newArray.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
  }
  return newArray;
}

type Props = {
  question: MatchQuestionType;
  showAnswer: boolean;
  questionIndex: number;
};

export default function MatchQuestion({
  question,
  showAnswer,
  questionIndex,
}: Props) {
  const {
    point,
    body,
    leftPart,
    rightPart,
    answer,
    image,
    mediaUrl,
    learningOutcome,
  } = question;

  let imageFile: string | Buffer | undefined;

  if (image && image.startsWith("data:image")) {
    const base64 = image.split(",")[1];
    const buff = Buffer.from(base64, "base64");
    imageFile = buff;
  } else if (image) {
    imageFile = image;
  } else if (mediaUrl) {
    imageFile = mediaUrl;
  }

  const leftPartEntries = [];

  for (const [key, value] of leftPart) {
    leftPartEntries.push([key, value]);
  }

  const rightPartEntries = [];

  for (const [key, value] of rightPart) {
    rightPartEntries.push([key, value]);
  }

  const shuffledRightPart = shuffleArray(rightPartEntries);

  return (
    <View
      style={[styles.questionContainerH, { marginVertical: 4 }]}
      wrap={false}
    >
      <View style={styles.questionContainerV}>
        <Text style={styles.questionNumber}>{`${questionIndex + 1}. `}</Text>
        <View style={styles.questionContainerH}>
          {imageFile && <Image src={imageFile} style={styles.questionImage} />}
          <View style={styles.questionContainerV}>
            <Text style={styles.questionBody}>
              {body}
              <Text style={styles.questionNumber}>
                {" "}
                ({point} {t("pdf_renderer.point")}){" "}
              </Text>
            </Text>
          </View>
          <View style={[styles.questionContainerH, styles.borderBottom]}>
            {leftPartEntries.map(([option, text]) => (
              <Text
                key={`${question.type}-${questionIndex}-left-option-${option}`}
                style={styles.questionBody}
              >
                {option}) {text}{" "}
                {showAnswer ? (
                  <Text style={styles.answer}> {answer.get(option)}</Text>
                ) : (
                  "__"
                )}
              </Text>
            ))}
          </View>
          <View style={styles.questionContainerH}>
            {shuffledRightPart.map(([, text], index) => (
              <Text
                key={`${question.type}-${questionIndex}-right-option-${index}`}
                style={styles.questionBody}
              >
                {String.fromCharCode("A".charCodeAt(0) + index)}) {text}
              </Text>
            ))}
          </View>
        </View>
      </View>
      {showAnswer && learningOutcome && (
        <Text style={[styles.answer, styles.questionBody]}>
          {t("pdf_renderer.outcome")}: {learningOutcome}
        </Text>
      )}
    </View>
  );
}
